import { useTheme } from "@mui/material"
import { SxGeneral } from "../../../../../../../utils/types/generals"

type StyleKey = 'card' | 'map' | 'scroll' | 'add' | 'header' | 'general' | 'container' | 'userContainer' | 'mark' | 'activityMark'

export const useStyles = (): SxGeneral<StyleKey> => {
    const { palette } = useTheme()
    return {
        card: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            flexWrap: 'wrap',
        },
        scroll: {
            maxHeight: '500px',
            overflow: 'scroll',
            scrollbarWidth: 'none', // Firefox
            msOverflowStyle: 'none', // Internet Explorer y Edge
            '&::-webkit-scrollbar': {
                display: 'none', // Chrome, Safari y WebKit
            },
            padding: '2px',
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
        },
        userContainer: {
            padding: 3,
            display: 'flex',
            gap: 2,
            flexWrap: 'wrap',
        },
        map: {
            minHeight: '500px',
            height: '100%',
            width: '100%',
            borderRadius: '10px',
            overflow: 'hidden',
            border: `1px solid ${palette.grey}55`,
        },
        add: {
            fontSize: '2rem',
            color: 'secondary.100'
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        general: {
            flex: 1
        },
        container: {
            gap: 2
        },
        mark: {
            position: 'absolute',
            top: '0',
            userSelect: 'none',
            transform: 'translate(0%, -50%)',
            zIndex: 0,
            width: '30px',
            height: '30px',
            '& img': {
                width: 'inherit',
                height: 'inherit',
                borderRadius: '50%',
                objectFit: 'cover',
                zIndex: 0,
            },
        },
        activityMark: ({ color }: { color: string }) => ({
            position: 'absolute',
            top: '0',
            userSelect: 'none',
            transform: 'translate(0%, -50%)',
            zIndex: 0,
            width: '40px',
            height: '40px',
            fontSize: '12px',
            backgroundColor: color,
            '& .MuiAvatar-root': {
                width: 'inherit',
                height: 'inherit',
                borderRadius: '50%',
                objectFit: 'cover',
                zIndex: 0,
            },
        })
    }
}